/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} DonateInputs */

const en_donate = /** @type {(inputs: DonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donate`)
};

const ar_donate = /** @type {(inputs: DonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تبرع`)
};

const de_donate = /** @type {(inputs: DonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spenden`)
};

const es_donate = /** @type {(inputs: DonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donar`)
};

const fr_donate = /** @type {(inputs: DonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faire un don`)
};

const it_donate = /** @type {(inputs: DonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dona`)
};

const ja_donate = /** @type {(inputs: DonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`寄付`)
};

const ko_donate = /** @type {(inputs: DonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기부`)
};

const pt_br_donate = /** @type {(inputs: DonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doar`)
};

const ru_donate = /** @type {(inputs: DonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожертвовать`)
};

const th_donate = /** @type {(inputs: DonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บริจาค`)
};

const tr_donate = /** @type {(inputs: DonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bağış Yap`)
};

const zh_cn_donate = /** @type {(inputs: DonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`捐献`)
};

const zh_tw_donate = /** @type {(inputs: DonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`捐獻`)
};

/**
* | output |
* | --- |
* | "Donate" |
*
* @param {DonateInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const donate = /** @type {((inputs?: DonateInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<DonateInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_donate(inputs)
	if (locale === "ar") return ar_donate(inputs)
	if (locale === "de") return de_donate(inputs)
	if (locale === "es") return es_donate(inputs)
	if (locale === "fr") return fr_donate(inputs)
	if (locale === "it") return it_donate(inputs)
	if (locale === "ja") return ja_donate(inputs)
	if (locale === "ko") return ko_donate(inputs)
	if (locale === "pt_br") return pt_br_donate(inputs)
	if (locale === "ru") return ru_donate(inputs)
	if (locale === "th") return th_donate(inputs)
	if (locale === "tr") return tr_donate(inputs)
	if (locale === "zh_cn") return zh_cn_donate(inputs)
	return zh_tw_donate(inputs)
});